import { ConsentActionStatus } from '../types';

export const consentListeners = () => {
  window.consentActions = {};

  const trackConsentMap = new Map();
  trackConsentMap.set('5e542b3a4cd8884eb41b5a72', 'google_analytics');

  /**
   * On every user consent action:
   *  - the consent status of each vendor will be stored in `window.consentActions[window.checkConsentMap.value]`
   *  - an `ndConsentAction` event will be fired. The vendor name can be accessed through `event.detail.vendor`
   *    and the consent action can be accessed through `event.detail.status`
   */
  let isFirstConsentCheck = true;
  window.__tcfapi('addEventListener', 2, (tcData, success) => {
    if (success) {
      // After the first run we need to check only the `useractioncomplete` events, since only them can lead to a
      // consent change
      if (isFirstConsentCheck || tcData.eventStatus === 'useractioncomplete') {
        isFirstConsentCheck = false;

        window.__tcfapi('getCustomVendorConsents', 2, function (data, success) {
          if (success) {
            trackConsentMap.forEach((value, key) => {
              if (!data.grants[key]) {
                return;
              }

              let status: ConsentActionStatus = 'Rejected';

              if (data.grants[key].vendorGrant) {
                status = 'Granted';
              }

              const vendorName = value;

              // Avoid dispatching unnecessary events when the consent status hasn't changed
              if (window.consentActions[vendorName] === status) {
                return;
              }

              // Avoid `boolean` to be able to check 3 states, `Granted`, `Rejected`, `undefined` (waiting the event)
              window.consentActions[vendorName] = status;

              document.dispatchEvent(new CustomEvent('ndConsentAction', {
                detail: {
                  vendor: vendorName,
                  status: status
                }
              }));
            });
          }
        });
      }
    }
  });
};
